<template>
  <div
    class="c-recentOrderServiceList"
    v-if="recentOrderServiceList.length"
  >
    <h2 class="c-recentOrderServiceList_title">
      <strong>直近で購入されたサービス</strong>
    </h2>
    <div
      class="c-recentOrderServiceList_item"
      v-for="service in serviceList"
      :key="service.orderDate"
    >
      <span>「{{ service.serviceName }}</span>
      <span class="c-recentOrderServiceList_user">
        by
        <a
          :href="addQueryToUrlIfBusinessPreview(`/users/${service.userId}`)"
          target="_blank"
          rel="noopener"
        >
          {{ getOmittedUserName(service.userName) }}
        </a>
      </span>
      <span>」が購入されました。</span>
    </div>
  </div>
</template>
<script>
import businessMixin from '~/mixins/pages/business-mixin'

import { mapState, mapGetters } from 'vuex'

const LIST_MAX_COUNT = 8
const USER_NAME_MAX_LENGTH_SP = 18

export default {
  name: 'RecentOrderServiceList',
  mixins: [businessMixin],
  computed: {
    ...mapState('pages/search/seo', ['recentOrderServiceList']),
    ...mapGetters('ui', ['isPC']),
    serviceList() {
      return this.recentOrderServiceList.slice(0, LIST_MAX_COUNT)
    }
  },
  methods: {
    getOmittedUserName(userName) {
      // PCでは省略しない
      if (this.isPC || userName.length <= USER_NAME_MAX_LENGTH_SP) {
        return userName
      }

      return userName.substr(0, USER_NAME_MAX_LENGTH_SP - 1) + '…'
    }
  }
}
</script>
<style lang="scss" scoped>
.c-recentOrderServiceList {
  margin-top: 40px;
  border-bottom: 1px solid $color-gray-200;
  font-size: 13px;

  a {
    @include link-effect;
  }

  p {
    margin: 0;
  }

  &_title {
    margin-bottom: 16px;

    strong {
      color: $color-gray-900;
    }
  }

  &_item {
    border-top: 1px solid $color-gray-200;
    line-height: 1.5;
  }

  &_user {
    font-size: 11px;
  }
}

@media (max-width: breakpoint(Search, M)) {
  .c-recentOrderServiceList {
    margin-right: 12px;
    margin-left: 12px;

    &_title {
      strong {
        font-size: 16px;
      }
    }

    &_item {
      padding: 16px 0;
      line-height: 1.3;
    }
  }
}

@media (min-width: breakpoint(Search, M) + 1) {
  .c-recentOrderServiceList {
    &_title {
      strong {
        font-size: 20px;
      }
    }

    &_item {
      overflow: hidden;
      padding: 12px 0;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
